import clsx from "clsx"

import {
  ImageGallery as ImageGalleryAbstract,
  type ImageGalleryProps as ImageGalleryAbstractProps,
} from "@unlikelystudio/react-abstract-components"

import CloseButton from "~/components/ui/CloseButton"
import { FillImage } from "~/components/ui/FillImage"
import { type ImageProps } from "~/components/ui/Image"

import * as css from "./styles.css"

export interface ImageGalleryProps extends ImageGalleryAbstractProps {
  imagesProps?: ImageProps[]
}

function ImageGallery({ className, imagesProps, ...props }: ImageGalleryProps) {
  if (!imagesProps) return null

  const imageProps = imagesProps?.[props?.imageIndex ?? 0]
  const images = [
    imageProps && (
      <FillImage key={"image"} className={css.imageItem} imageClassName={clsx(css.image)} {...imageProps} />
    ),
  ].filter(Boolean)

  return (
    <ImageGalleryAbstract
      classes={{
        ImageGallery: clsx(className, css.ImageGallery),
        slider: clsx(css.slider),
        imageContainer: clsx(css.imageContainer),
        image: clsx(css.image),
        closeButton: clsx(css.closeButton),
      }}
      buttonComponent={<CloseButton />}
      images={images}
      {...props}
    />
  )
}

export default ImageGallery
